<div class="modal-header pt-3">
  <h4 class="modal-title">Texas Officials</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
</div>
<div class="modal-body">
  <tx-loader-wrapper [isLoading]="loading">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center gap-2">
        <label>Office:</label>
        <div class="flex-grow">
          <select class="form-select" (change)="onSelectOfficeType($event)">
            <option
              *ngFor="let officeType of officesPerType"
              [value]="officeType.officeType"
              [selected]="selectedOfficeType === officeType">
              {{ officeType.officeTypeName }}
            </option>
          </select>
        </div>
      </div>
      <div class="filter-container">
        <input
          #filterInput
          type="text"
          class="form-control"
          [(ngModel)]="filterText"
          placeholder="Start typing to filter the list"
          (ngModelChange)="onFilterChange()" />
        <a href="#" (click)="clearFilter()" class="clear-button" *ngIf="searchTerm$ | async">
          <i class="bi bi-x-lg"></i>
        </a>
      </div>
    </div>
    <div>
      <select class="form-select" size="15" (change)="onSelectOffice($event)">
        <option *ngFor="let office of filteredOffices">{{ office.officeName }}</option>
      </select>
    </div>
  </tx-loader-wrapper>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    (click)="modal.close(selectedOffice.envAddress)"
    [disabled]="!selectedOffice">
    Insert selected address
  </button>
</div>
